import { Injectable } from '@angular/core';
import { LookupViewModel, Response } from '../models/generated-view-models';
import { URLS } from '../shared/url';
import { RefEntityTypeEnum } from '../models/enums';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

interface ILoolupCacheResponce {
    [key: string]: LookupViewModel[]
}

@Injectable({
    providedIn: 'root'
})
export class LookupCacheService {

    private lookups: ILoolupCacheResponce;
    private refEntityTypeEnum = RefEntityTypeEnum;

    constructor(
        private http: HttpClient) { 
    }

    public load = (apiServerURL: string): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            this.http.get(`${apiServerURL}${URLS.getAllCacheLookups}`).toPromise().then((response: Response<ILoolupCacheResponce>) => {
                this.lookups = response.result;
                resolve();
            }).catch((err: HttpErrorResponse) => {
                reject(`Could not load cache service`);
            });
        }); 
    }

    public get allLookups(): ILoolupCacheResponce {
        return this.lookups;
    }

    public get getStatus(): LookupViewModel[] {
        return this.lookups.RefStatusType;
    }

    public getLookupCache = (entityType: RefEntityTypeEnum) => {
        return this.lookups[this.refEntityTypeEnum[entityType]];
    }
}
